if (!customElements.get('scene-card-accordion')) {
  customElements.define('scene-card-accordion', class SceneCardAccordion extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-scene-card]')];
      this.track = this.querySelector('.scene-card-accordion__track');
      this.activeIndex = Math.max(0, this.cards.findIndex((card) => card.classList.contains('is-active')));
      this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      this.abortController = new AbortController();
      this.updateContentWidth();
      this.resizeObserver = new ResizeObserver(() => this.updateContentWidth());
      if (this.track) this.resizeObserver.observe(this.track);

      this.cards.forEach((card, index) => {
        card.addEventListener('pointerenter', () => {
          if (this.hoverQuery.matches) this.activate(index);
        }, { signal: this.abortController.signal });
        card.addEventListener('click', (event) => {
          if (event.target.closest('a, anchor-button')) return;
          if (window.innerWidth >= 990) this.activate(index);
        }, { signal: this.abortController.signal });
        card.addEventListener('keydown', (event) => {
          if (event.target.closest('a, anchor-button')) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.activate(index);
          }
          if (event.key === 'ArrowRight') this.activate(Math.min(this.cards.length - 1, index + 1), true);
          if (event.key === 'ArrowLeft') this.activate(Math.max(0, index - 1), true);
        }, { signal: this.abortController.signal });
      });

      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest?.('[data-scene-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.activate(index);
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.resizeObserver?.disconnect();
    }

    updateContentWidth() {
      if (!this.track || window.innerWidth < 990) return;
      const activePercent = parseFloat(getComputedStyle(this).getPropertyValue('--sca-active-width')) || 67;
      const finalCardWidth = this.track.clientWidth * activePercent / 100;
      this.style.setProperty('--sca-final-card-width', `${finalCardWidth}px`);
      this.style.setProperty('--sca-final-content-width', `${Math.max(300, finalCardWidth - 88)}px`);
    }

    activate(index, moveFocus = false) {
      if (index === this.activeIndex || !this.cards[index]) return;
      const previousIndex = this.activeIndex;
      this.activeIndex = index;
      this.cards.forEach((card, cardIndex) => {
        const active = cardIndex === index;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-expanded', active ? 'true' : 'false');
        card.removeAttribute('data-expand-direction');
      });
      this.cards[index].dataset.expandDirection = previousIndex < index ? 'left' : 'right';
      if (moveFocus) this.cards[index].focus({ preventScroll: true });
    }
  });
}
